export enum DeductionDetailSection {
	Employee = 'Employee',
	Employer = 'Employer',
}

export enum DeductionStandardFlag {
	EmployeeStandard = 'EmployeeStandardFlag',
	EmployerMatching = 'EmployerMatchingFlag',
	EmployerStandard = 'EmployerStandardFlag',
}
